import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from "./../../ViewUtils";
import { SelectItem } from '../../widgets/SelectItem';
import { CustomTextField } from '../../widgets/CustomTextField';

const utils = new ViewUtils();

export const SkillsReportForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);
    const paramArray = !utils.isNull(props.skillsReportDetails) && !utils.isNull(props.skillsReportDetails.ReportParameters) 
        ? props.skillsReportDetails.ReportParameters.split(",") 
        : [];

    // Greatly simplified: Removes suffixes and adds spaces before capital letters
    const getName = (name) => {
        // 1. Remove the known suffixes from the end of the string
        let cleanedName = name.replace(/(FYSHF|FY|ID)$/, '');
        // 2. Insert space before Capital letters and trim
        return cleanedName.replace(/([A-Z])/g, ' $1').trim();
    };

    function GetIDValue(value) {
        return (value !== undefined && value !== null) ? value.Id : "0";
    }

    return (
        <EntityForm 
            ref={ref} 
            viewId="SkillsReports" 
            values={props.data}
            entityLookupController={props.entityLookupController} 
            org="saseta"
            entityLookupId={props.id} 
            useCustomSettings={false} 
            valueChangeHandler={props.valueChangeHandler}
        >
            {form =>
                <form className={form.classes.container} id="SkillsReportForm">
                    <div className="row search-form-container">
                        {
                            paramArray.map(parameter => {
                                let field = null;

                                // IMPORTANT: Check for FYSHF before FY, otherwise FY will trigger first!
                                if (parameter.endsWith("FYSHF")) {
                                    field = (
                                        <div key={parameter} className="col form-col">
                                            <SelectItem
                                                dataUrl={'api/sims/SkillsReportsDetails/GetFinancialYearSpecificSHF?parameter=[{"Name":"FinancialYearID","Value":' + GetIDValue(form.values["FinancialYearID"]) + '}]'}
                                                id={"FinancialYearID"}
                                                label={getName("FinancialYearID")}
                                                className="w-100"
                                                allowEmptyValue={false}
                                                form={form}
                                            />
                                        </div>
                                    );
                                }
                                else if (parameter.endsWith("FY")) {
                                    field = (
                                        <div key={parameter} className="col form-col">
                                            <SelectItem
                                                dataUrl={'api/sims/SkillsReportsDetails/GetFinancialYearSpecific?parameter=[{"Name":"FinancialYearID","Value":' + GetIDValue(form.values["FinancialYearID"]) + '}]'}
                                                id={"FinancialYearID"}
                                                label={getName("FinancialYearID")}
                                                className="w-100"
                                                allowEmptyValue={true}
                                                form={form}
                                            />
                                        </div>
                                    );
                                }
                                else if (parameter.endsWith("ID")) {
                                    field = (
                                        <div key={parameter} className="col form-col">
                                            <SelectItem
                                                dataUrl={"api/sims/SkillsReportsDetails/GetLookupList?listId=" + parameter}
                                                id={parameter}
                                                label={getName(parameter)}
                                                className="w-100"
                                                allowEmptyValue={true}
                                                form={form}
                                            />
                                        </div>
                                    );
                                }
                                else if (parameter.length > 0) {
                                    // Fixed DOM Nesting: Replaced <tr><td> with matching Bootstrap <div> columns
                                    field = (
                                        <div key={parameter} className="col form-col">
                                            <CustomTextField
                                                id={parameter}
                                                label={getName(parameter)}
                                                className="w-50"
                                                InputProps={{
                                                    readOnly: false,
                                                }}
                                                form={form}
                                            />
                                        </div>
                                    );
                                }
                                return field;
                            })
                        }
                    </div>
                </form>
            }
        </EntityForm>
    );
});